import * as Yup from "yup";
import { PAN_REGEX } from "../config/constant";

// Validation rules for the Basic Details step. Every later step of the
// membership forms re-checks these before submitting, so keep this file as the
// single source of truth for Basic Details required fields.
export function basicDetailsRules(currentMembership) {
  const isNonStar =
    !!currentMembership && currentMembership?.name.toLowerCase() !== "star";

  const requiredIfNonStar = (message) =>
    isNonStar ? Yup.string().required(message) : Yup.string().notRequired();

  const requiredForOrgType = (orgType, message) =>
    Yup.string().when(["org_type"], {
      is: (org_type) =>
        isNonStar && !!org_type && org_type.toLowerCase() === orgType,
      then: () => Yup.string().required(message),
      otherwise: () => Yup.string().notRequired(),
    });

  return {
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email"),
    dob: Yup.string().required("Date of birth is required"),
    mobile_number: Yup.string()
      .required("Whatsapp number is required")
      .min(6, "Please enter a valid number"),
    primary_number: Yup.string()
      .required("Primary mobile number is required")
      .min(6, "Please enter a valid number"),
    state: Yup.string().required("State is required"),
    zone: Yup.string().required("Zone is required"),
    registered_address: Yup.string().required(
      "Registered Office address is required"
    ),
    size_of_company: requiredIfNonStar("Size of company is required"),
    incorporation_date: Yup.string().when(["org_type"], {
      is: (org_type) =>
        isNonStar && !!org_type && org_type.toLowerCase() !== "huf",
      then: () => Yup.string().required("Incorporation date is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    // GST number and document are optional for star membership
    gst_number: requiredIfNonStar("GST number is required"),
    gst_proof: requiredIfNonStar("GST Document is required"),
    aadhar_proof: Yup.string().required("Aadhar Card is required"),
    pan_proof: Yup.string().required("PAN Card is required"),
    pan_number: Yup.string()
      .required("PAN number is required")
      .matches(PAN_REGEX, "Please enter a valid PAN number"),
    org_type: requiredIfNonStar("Company type is required"),
    company_name: Yup.string().required("Company name is required"),
    moa: requiredForOrgType("company", "MOA is required"),
    aoa: requiredForOrgType("company", "AOA is required"),
    portaldirector: requiredForOrgType(
      "company",
      "Director Details is required"
    ),
    resolution: requiredForOrgType("company", "Resolution is required"),
    incorporation_certificate: requiredForOrgType(
      "company",
      "Incorporation certificate is required"
    ),
    repersentative_photo: Yup.string().required(
      "Representative photo is required"
    ),
    deed: requiredForOrgType("partnership", "Deed is required"),
    authorization: requiredForOrgType(
      "partnership",
      "Authorization is required"
    ),
    huf_authorization: requiredForOrgType("huf", "Authorization is required"),
    address_proof: Yup.string().required("Address proof is required"),
    turn_over_amount: requiredIfNonStar(
      "First year turnover amount is required"
    ),
    turn_over_year: requiredIfNonStar("First turnover year is required"),
    turn_over_amount_2: requiredIfNonStar(
      "Second year turnover amount is required"
    ),
    turn_over_year_2: requiredIfNonStar("Second turnover year is required"),
    turnover_certificate: requiredIfNonStar("Turnover certificate is required"),
  };
}

// Field names owned by the Basic Details step, used by later steps to decide
// whether a validation error should send the user back to Basic Details.
export const BASIC_DETAIL_FIELDS = Object.keys(basicDetailsRules(null));
